import React from 'react';
import CustomScroll from 'react-custom-scroll';
import { FormattedDate, FormattedMessage } from 'react-intl';
import { ICalendar } from 'src/entities/calendar';
import PrimaryButton from '../form-components/PrimaryButton/PrimaryButton';
import SecondaryButton from '../form-components/SecondaryButton/SecondaryButton';
import { IPopupable } from '../Popup/Popup';
import globalMessages from 'src/services/globalMessages';
import { useStyleLinks } from 'src/hooks';
import { useRef } from 'react';

interface ICalendarDescriptionProps extends IPopupable {
    calendar: ICalendar;
    firstFreeSlot: Date | null;
    startReservation: () => void;
}

const CalendarDescription: React.FunctionComponent<ICalendarDescriptionProps> = props => {
    const { Description } = props.calendar;
    const { firstFreeSlot, closePopup, startReservation } = props;
    const handleOk = () => {
        closePopup?.();
        startReservation();
    }

    const bodyRef = useRef<HTMLDivElement>(null);
    useStyleLinks(bodyRef);

    return (
        <section className="calendar-description">
            {firstFreeSlot &&
                <div className="calendar-description__details">
                    <FormattedMessage {...globalMessages.firstFreeSlot} />{': '}
                    <FormattedDate value={firstFreeSlot} />
                </div>
            }
            {Description &&
                <CustomScroll>
                    <div ref={bodyRef} className="calendar-description__body" dangerouslySetInnerHTML={{ __html: Description }} />
                </CustomScroll>
            }
            <div className="calendar-description__buttons">
                {closePopup && <SecondaryButton className="calendar-description__button calendar-description__cancel" onClick={closePopup} caption={globalMessages.close} />}
                <PrimaryButton className="calendar-description__button" onClick={handleOk} caption={globalMessages.firstStepAction} />
            </div>
        </section>
    );
}

export default CalendarDescription;